import { useMemo } from "react";
import { ProductBySlugQuery } from "services/datocms/generated";
import { useGetItemsByGtinQuery } from "services/graphql/generated";

export const useGetPepdirectCylinders = (
  cylinderTypes:
    | NonNullable<ProductBySlugQuery["product"]>["cylinderTypes"]
    | null
    | undefined,
) => {
  const allCylindersGtins = useMemo(() => {
    const allCylindersGtins: string[] = [];
    cylinderTypes?.forEach((cylinder) => {
      if (cylinder.gtin) {
        allCylindersGtins.push(cylinder.gtin);
      }
      if (cylinder.spareCylinder) {
        allCylindersGtins.push(cylinder.spareCylinder.gtin ?? "");
      }
    });
    return allCylindersGtins;
  }, [cylinderTypes]);

  const query = useGetItemsByGtinQuery({
    variables: {
      gtins: allCylindersGtins,
    },
  });
  const allPepDirectCylinders = query.data?.items?.items;

  return { allPepDirectCylinders, query };
};
